import React, { useState, useEffect } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import logo from "../images/SalaryMates_logo.png";
import { getStorage } from "../Utils/common";

const Header = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [eligibility, setEligibility] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = getStorage("token");
    const eligibilityStatus = getStorage("eligibility");

    if (token) {
      setIsLoggedIn(true);
    }

    if (eligibilityStatus) {
      setEligibility(eligibilityStatus);
    }
  }, []);

  const handleDashboardClick = () => {
    if (eligibility === 1) {
      navigate("/my-dashboard/eligibility");
    } else {
      navigate("/my-dashboard");
    }
    setMenuOpen(false);
  };

  return (
    <div className="bg-[#0A1620] relative shadow-md w-full z-50">
      <nav className="flex items-center justify-between px-5 md:px-12 h-20">
        {/* Logo */}
        <div className="flex items-center">
          <Link to="/">
            <img
              src={logo}
              alt="logo"
              className="rounded-2xl p-3 w-38 h-20 drop-shadow-md"
            />
          </Link>
        </div>

        {/* Burger for mobile */}
        <div
          className="md:hidden flex-col z-20 justify-center cursor-pointer space-y-1"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className="block w-6 h-0.5 bg-white"></span>
          <span className="block w-6 h-0.5 bg-white"></span>
          <span className="block w-6 h-0.5 bg-white"></span>
        </div>

        {/* Nav Links */}
        <ul
          className={`p-2 md:p-0 pt-1 flex flex-col md:flex-row items-center absolute md:static bg-[#0A1620] md:bg-transparent w-full md:w-auto top-[100%] -left-[100%] transition-all duration-300 ease-in-out 
            ${
              menuOpen
                ? "left-[0] opacity-100"
                : "-left-[100%] opacity-0 md:opacity-100"
            } md:opacity-100`}
        >
          <li className="px-3 py-1 md:px-4 md:py-2">
            <NavLink
              to="/home"
              className={({ isActive }) =>
                `block text-white md:text-white hover:text-white/80 transition relative font-bold
                ${isActive ? 'after:content-[""] after:absolute after:left-0 after:right-0 after:-bottom-1 after:h-0.5 after:bg-white after:rounded-full' : ""}`
              }
              onClick={() => setMenuOpen(false)}
            >
              Home
            </NavLink>
          </li>

          <li className="px-3 py-1 md:px-4 md:py-2">
            <NavLink
              to="/about-us"
              className={({ isActive }) =>
                `block text-white md:text-white hover:text-white/80 transition relative font-bold
                ${isActive ? 'after:content-[""] after:absolute after:left-0 after:right-0 after:-bottom-1 after:h-0.5 after:bg-white after:rounded-full' : ""}`
              }
              onClick={() => setMenuOpen(false)}
            >
              About
            </NavLink>
          </li>

          <li className="px-3 py-1 md:px-4 md:py-2">
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                `block text-white md:text-white hover:text-white/80 transition relative font-bold
                ${isActive ? 'after:content-[""] after:absolute after:left-0 after:right-0 after:-bottom-1 after:h-0.5 after:bg-white after:rounded-full' : ""}`
              }
              onClick={() => setMenuOpen(false)}
            >
              Contact
            </NavLink>
          </li>

           <li className="px-3 py-1 md:px-4 md:py-2">
            <NavLink
              to="/counselling"
              className={({ isActive }) =>
                `block text-white md:text-white hover:text-white/80 transition relative font-bold
                ${isActive ? 'after:content-[""] after:absolute after:left-0 after:right-0 after:-bottom-1 after:h-0.5 after:bg-white after:rounded-full' : ""}`
              }
              onClick={() => setMenuOpen(false)}
            >
              Counselling
            </NavLink>
          </li>

          <li className="px-4 py-1">
            {isLoggedIn ? (
              <button
                className="bg-white
            text-[#0A1620] px-6 py-3 md:px-4 md:py-2
            rounded-xl font-bold
            shadow-md hover:shadow-lg hover:scale-105 transition-all
            w-full md:w-auto"
                onClick={handleDashboardClick}
              >
                Dashboard
              </button>
            ) : (
              <NavLink
                to="/apply-now"
                className="bg-white text-[#0A1620] hover:bg-gray-100 hover:scale-105 transition-all px-5 py-3 md:px-4 md:py-2
            rounded-xl font-bold
            shadow-md hover:shadow-lg
            block text-center"
                onClick={() => setMenuOpen(false)}
              >
                Apply Now
              </NavLink>
            )}
          </li>

          <li className="px-4 py-1">
            <NavLink
              to="/repayloan"
              className={({ isActive }) =>
                `border-2 border-white
          px-5 py-3 md:px-4 md:py-2 bg-white
          rounded-xl hover:bg-white text-[#0A1620] 
          transition-all block text-center font-bold
          ${isActive ? "bg-white text-[#0A1620]" : ""}`
              }
              onClick={() => setMenuOpen(false)}
            >
              Repay Loan
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Header;